import { createContext, useContext } from "react";

const LangContext = createContext({ lang: "en", t: (k) => k, setLang: () => {} });

export const useLang = () => useContext(LangContext);

const dict = {
  en: {
    "hero.reserve": "Reserve Your Sanctuary",
    "hero.explore": "Explore Villa Stay",
    "hero.eyebrow": "Nusa Lembongan, Bali",
    "nav.dining": "Dining",
    "nav.offers": "Offers",
    "nav.schedule": "Boat Schedule",
    "schedule.eyebrow": "Getting Here",
    "schedule.title": "Sanur Harbour Fast Boat Timetable",
    "schedule.intro": "Plan your crossing to Nusa Lembongan with the latest published fast boat schedule. Times can change with sea conditions, so our concierge remains available to help arrange the smoothest arrival.",
    "schedule.route": "Sanur ↔ Nusa Lembongan",
    "schedule.companies": "boat companies serving Lembongan",
    "schedule.bookCta": "Let Us Book Your Boat",
    "schedule.fromSanur": "Sanur → Lembongan",
    "schedule.fromLembongan": "Lembongan → Sanur",
    "schedule.notPublished": "Schedule not published",
    "schedule.disclaimer": "Schedules can change with weather and crossing safety.",
    "schedule.note": "Live schedule reference",
    "schedule.toIsland": "Sanur to Lembongan",
    "schedule.toSanur": "Lembongan to Sanur",
    "schedule.updated": "Schedule checked",
    "schedule.stale": "Last available schedule",
    "schedule.source": "Source: Sanur Harbour",
    "schedule.error": "The timetable is temporarily unavailable.",
    "schedule.empty": "No published crossings are available for this direction right now.",
    "schedule.stepRoute": "1 · Route",
    "schedule.stepCompany": "2 · Boat Company",
    "schedule.stepDate": "3 · Departure Date",
    "schedule.chooseCompany": "Choose boat company",
    "schedule.departures": "Departure times (daily)",
    "schedule.placeholder": "Choose a route, boat company and date to see the full crossing details.",
    "schedule.manual": "Updated by villa",
    "dining.eyebrow": "Dining",
    "dining.title": "The Island Table",
    "dining.intro": "From floating breakfasts in your pool to candlelit seafood on the sand - every meal is composed around you.",
    "dining.reserve": "Reserve",
    "offers.eyebrow": "Offers",
    "offers.title": "Stay Longer, Indulge More",
    "offers.intro": "Seasonal privileges for guests who book direct.",
    "offers.book": "Book This Offer",
    "villa.detail": "View Villa Details",
    "vd.amenities": "Amenities & Services",
    "vd.gallery": "Villa Gallery",
    "vd.back": "Back to Overview",
    "vd.book": "Reserve This Villa",
    "vd.from": "From",
    "vd.perNight": "/ night",
    "nav.about": "About",
    "nav.stay": "Stay",
    "nav.experiences": "Experiences",
    "nav.gallery": "Gallery",
    "nav.blog": "Blog",
    "nav.contact": "Contact Us",
    "nav.book": "Book Now",
    "book.checkin": "Check-in",
    "book.selectDate": "Select date",
    "book.checkout": "Check-out",
    "book.rooms": "Rooms",
    "book.adults": "Adults",
    "book.children": "Children",
    "book.cta": "Check Availability",
    "book.guests": "Guests",
    "book.nights": "Nights",
    "book.promo": "Promo Code",
    "book.promoPh": "Optional",
    "book.close": "Close",
    "book.notConfigured": "Online reservations are being set up. Please contact us directly to reserve.",
    "book.pageEyebrow": "Direct Reservation",
    "book.pageTitle": "Book Your Stay",
    "book.pageSubtitle": "Best direct rate, secure payment and instant confirmation - without leaving our website.",
    "book.loading": "Loading our secure booking engine...",
    "book.redirecting": "Redirecting to our secure booking page...",
    "book.opening": "Our secure booking window is opening...",
    "book.reopenHint": "The booking window was opened. Closed it? You can open it again below.",
    "book.openNow": "Open Booking Window",
    "book.openFull": "Open the full booking page",
    "factsheet.download": "Download Factsheet",
    "mq.1": "Nusa Lembongan",
    "mq.2": "Three-Bedroom Private Villa",
    "mq.3": "Private Pool",
    "mq.4": "Curated Island Experiences",
    "mq.5": "Sunset Decks",
    "mq.6": "Crafted Hospitality",
    "about.eyebrow": "Our Story",
    "about.title": "Savor the Quiet Splendor of Lembongan",
    "about.body": "Nusadira began as a family cliffside retreat on Nusa Lembongan - a place where days are measured in tides, not hours. Today it is a three-bedroom private villa with its own pool, held together by one belief: true luxury is space, silence and sincere island hospitality.",
    "about.quote": "\u201CNusadira\u201D - from nusa, island, and dira, the one who watches over. The island that watches over you.",
    "about.stat1_value": "3",
    "about.stat1_label": "Bedrooms",
    "about.stat2_value": "4.9",
    "about.stat2_label": "Guest Rating",
    "about.stat3_value": "24/7",
    "about.stat3_label": "Concierge",
    "stat.1": "Bedrooms",
    "stat.2": "Guest Rating",
    "stat.3": "Concierge",
    "villas.eyebrow": "Stay",
    "villas.title": "Your Three-Bedroom Island Sanctuary",
    "villas.intro": "One villa, entirely yours - three bedrooms, a private pool, open-air living and a dedicated host a message away.",
    "villas.from": "From",
    "villas.perNight": "/ night",
    "villas.reserve": "Reserve",
    "exp.eyebrow": "Experiences",
    "exp.title": "Curated Island Encounters",
    "exp.intro": "From manta rays at dawn to candlelit dinners on the sand - our concierge composes each day around you.",
    "exp.book": "Arrange",
    "gallery.eyebrow": "Gallery",
    "gallery.title": "A Visual Journal",
    "reviews.eyebrow": "Testimonials",
    "reviews.title": "Guest Stories & Reflections",
    "reviews.via": "via",
    "blog.eyebrow": "Insights & Guides",
    "blog.title": "The Lembongan Journal",
    "blog.read": "Read Story",
    "blog.back": "Back to Journal",
    "blog.related": "Related Links",
    "contact.eyebrow": "Contact Us",
    "contact.title": "Connect With Our Concierge",
    "contact.intro": "Tell us when the island should expect you. Our concierge replies personally to every message - usually within a few hours.",
    "contact.name": "Full Name",
    "contact.emailPh": "Email Address",
    "contact.phone": "Phone Number",
    "contact.company": "Company / Travel Agent (optional)",
    "contact.message": "Your message...",
    "contact.send": "Send Message",
    "contact.directions": "Get Directions",
    "contact.viewOnMaps": "View on Google Maps",
    "contact.sending": "Sending...",
    "contact.success": "Thank you - our concierge will reply within 24 hours.",
    "captcha.label": "I'm not a robot",
    "captcha.verify": "Quick check",
    "captcha.ph": "Your answer",
    "captcha.failed": "Verification failed. Please try again.",
    "type.1": "Reservation",
    "type.2": "Experiences",
    "type.3": "Events & Weddings",
    "type.4": "Press",
    "type.5": "General",
    "footer.tagline": "A private ocean sanctuary - a three-bedroom villa with its own pool on Nusa Lembongan, Bali.",
    "footer.rights": "All rights reserved.",
    "footer.member": "Member of",
    "promo.eyebrow": "Limited Privilege",
    "promo.aria": "Current promotion",
    "wa.aria": "Chat with our concierge on WhatsApp",
  },
  id: {
    "nav.about": "Tentang",
    "nav.stay": "Menginap",
    "nav.experiences": "Pengalaman",
    "nav.gallery": "Galeri",
    "nav.blog": "Blog",
    "nav.contact": "Hubungi Kami",
    "nav.book": "Pesan Sekarang",
    "book.checkin": "Check-in",
    "book.selectDate": "Pilih tanggal",
    "book.checkout": "Check-out",
    "book.rooms": "Kamar",
    "book.adults": "Dewasa",
    "book.children": "Anak-anak",
    "book.cta": "Cek Ketersediaan",
    "book.guests": "Tamu",
    "book.nights": "Malam",
    "book.promo": "Kode Promo",
    "book.promoPh": "Opsional",
    "book.close": "Tutup",
    "book.notConfigured": "Reservasi online sedang disiapkan. Silakan hubungi kami langsung untuk memesan.",
    "book.pageEyebrow": "Reservasi Langsung",
    "book.pageTitle": "Pesan Masa Inap Anda",
    "book.pageSubtitle": "Harga langsung terbaik, pembayaran aman dan konfirmasi instan - tanpa meninggalkan website kami.",
    "book.loading": "Memuat mesin pemesanan aman kami...",
    "book.redirecting": "Mengalihkan ke halaman pemesanan aman kami...",
    "book.opening": "Jendela pemesanan aman kami sedang dibuka...",
    "book.reopenHint": "Jendela pemesanan sudah dibuka. Tertutup? Anda dapat membukanya kembali di bawah.",
    "book.openNow": "Buka Jendela Pemesanan",
    "book.openFull": "Buka halaman pemesanan penuh",
    "factsheet.download": "Unduh Factsheet",
    "mq.1": "Nusa Lembongan",
    "mq.2": "Villa Privat 3 Kamar Tidur",
    "mq.3": "Kolam Renang Pribadi",
    "mq.4": "Pengalaman Pulau Pilihan",
    "mq.5": "Dek Matahari Terbenam",
    "mq.6": "Keramahan Khas Bali",
    "about.eyebrow": "Cerita Kami",
    "about.title": "Nikmati Ketenangan Memukau Lembongan",
    "about.body": "Nusadira berawal dari peristirahatan keluarga di tepi tebing Nusa Lembongan - tempat hari-hari diukur oleh pasang surut, bukan jam. Kini ia menjadi villa privat tiga kamar tidur dengan kolam renang pribadi, berdiri di atas satu keyakinan: kemewahan sejati adalah ruang, keheningan, dan keramahan pulau yang tulus.",
    "about.quote": "\u201CNusadira\u201D - dari nusa, pulau, dan dira, sang penjaga. Pulau yang menjaga Anda.",
    "stat.1": "Kamar Tidur",
    "stat.2": "Rating Tamu",
    "stat.3": "Concierge",
    "villas.eyebrow": "Menginap",
    "villas.title": "Santuari Pulau Tiga Kamar Tidur Anda",
    "villas.intro": "Satu villa, sepenuhnya milik Anda - tiga kamar tidur, kolam renang pribadi, ruang terbuka, dan tuan rumah khusus yang siap membantu kapan saja.",
    "villas.from": "Mulai",
    "villas.perNight": "/ malam",
    "villas.reserve": "Reservasi",
    "exp.eyebrow": "Pengalaman",
    "exp.title": "Pengalaman Pulau Pilihan",
    "exp.intro": "Dari pari manta saat fajar hingga makan malam romantis di pasir - concierge kami menyusun setiap hari untuk Anda.",
    "gallery.eyebrow": "Galeri",
    "gallery.title": "Jurnal Visual",
    "reviews.eyebrow": "Testimoni",
    "reviews.title": "Kisah & Kesan Tamu",
    "reviews.via": "via",
    "blog.eyebrow": "Wawasan & Panduan",
    "blog.title": "Jurnal Lembongan",
    "blog.read": "Baca Cerita",
    "blog.back": "Kembali ke Journal",
    "blog.related": "Tautan Terkait",
    "contact.eyebrow": "Hubungi Kami",
    "contact.title": "Terhubung Dengan Concierge Kami",
    "contact.intro": "Beri tahu kami kapan pulau harus menyambut Anda. Concierge kami membalas setiap pesan secara personal - biasanya dalam beberapa jam.",
    "contact.name": "Nama Lengkap",
    "contact.company": "Perusahaan / Travel Agent (opsional)",
    "contact.emailPh": "Alamat Email",
    "contact.phone": "Nomor Telepon",
    "contact.message": "Pesan Anda...",
    "contact.send": "Kirim Pesan",
    "contact.directions": "Petunjuk Arah",
    "contact.viewOnMaps": "Lihat di Google Maps",
    "contact.sending": "Mengirim...",
    "contact.success": "Terima kasih - concierge kami akan membalas dalam 24 jam.",
    "captcha.label": "Saya bukan robot",
    "captcha.verify": "Pengecekan cepat",
    "captcha.ph": "Jawaban Anda",
    "captcha.failed": "Verifikasi gagal. Silakan coba lagi.",
    "type.1": "Reservasi",
    "type.2": "Pengalaman",
    "type.3": "Acara & Pernikahan",
    "type.4": "Pers",
    "type.5": "Umum",
    "footer.tagline": "Santuari samudra pribadi - villa tiga kamar tidur dengan kolam renang pribadi di Nusa Lembongan, Bali.",
    "footer.rights": "Hak cipta dilindungi.",
    "footer.member": "Bagian dari",
    "wa.aria": "Chat dengan concierge kami di WhatsApp",
  },
};

export const pick = (obj, field, lang) => {
  if (!obj) return "";
  if (lang === "id" && obj[`${field}_id`]) return obj[`${field}_id`];
  return obj[field] || "";
};

let siteOverrides = {};
export const setSiteOverrides = (content) => {
  siteOverrides = {};
  Object.entries(content || {}).forEach(([k, doc]) => {
    Object.entries(doc || {}).forEach(([f, v]) => {
      if (typeof v === "string" && v) siteOverrides[`${k}.${f}`] = v;
    });
  });
};

export function LanguageProvider({ children }) {
  const t = (key) => siteOverrides[key] ?? dict.en[key] ?? key;
  return <LangContext.Provider value={{ lang: "en", t, setLang: () => {} }}>{children}</LangContext.Provider>;
}
